export const partners = [
  {
    id:"britguard", name:"BritGuard", category:"Fire Fighting", categoryAr:"إطفاء الحرائق",
    logoText:"BG", accent:"#c0392b", categoryIcon:"fa-fire-extinguisher",
    tagline:"Official Fire Suppression Systems Partner",
    taglineAr:"الشريك الرسمي لأنظمة إخماد الحرائق",
    about:"BritGuard is a leading manufacturer of industrial-grade fire suppression equipment, certified to UL and FM standards, supplying heavy-duty sprinkler heads, valves, and detection components.",
    aboutAr:"بريتغارد هي شركة رائدة في تصنيع معدات إخماد الحرائق الصناعية، معتمدة بمعايير UL وFM، وتوفر رشاشات الحريق وصمامات التحكم ومكونات الكشف عالية الجودة.",
    products:["Industrial Sprinkler Heads","Deluge Valves","Foam Concentrate Tanks","Anti-Freeze Loop Components"],
    productsAr:["رشاشات حريق صناعية","صمامات طوفان","خزانات مركز الرغوة","مكونات الحلقة المضادة للتجمد"],
    certificates:["UL Listed","FM Approved","NFPA 13 Compliant","CE Certified"],
    applications:["Warehouses","Petroleum Facilities","Industrial Plants","Chemical Storage"],
    applicationsAr:["المستودعات","منشآت البترول","المصانع الصناعية","مخازن المواد الكيميائية"],
    catalog:"#",
  },
  {
    id:"lubi", name:"Lubi Pumps", category:"Pump Systems", categoryAr:"أنظمة المضخات",
    logoText:"LB", accent:"#2980b9", categoryIcon:"fa-faucet-drip",
    tagline:"Certified Fire & Industrial Pump Partner",
    taglineAr:"الشريك المعتمد لمضخات الحريق والصناعة",
    about:"Lubi is an internationally recognized pump manufacturer delivering high-capacity fire pumps, jockey pumps, and variable speed systems certified under NFPA 20 and UL 448.",
    aboutAr:"لوبي شركة عالمية متخصصة في تصنيع المضخات، تقدم مضخات حريق عالية الطاقة ومضخات جوكي وأنظمة سرعة متغيرة معتمدة بمعايير NFPA 20 وUL 448.",
    products:["Electric Fire Pumps","Diesel Engine Pumps","Jockey Pressure Pumps","Variable Speed Drives"],
    productsAr:["مضخات حريق كهربائية","مضخات ديزل","مضخات ضغط جوكي","محركات سرعة متغيرة"],
    certificates:["UL 448 Listed","FM Approved","NFPA 20","BIS Certified"],
    applications:["Fire Fighting Systems","Municipal Water Supply","Industrial Cooling","High-Rise Buildings"],
    applicationsAr:["أنظمة الإطفاء","إمدادات المياه البلدية","التبريد الصناعي","المباني الشاهقة"],
    catalog:"#",
  },
  {
    id:"titans", name:"Titans Fire Cabinets", category:"Fire Cabinets", categoryAr:"خزائن الحريق",
    logoText:"TT", accent:"#e67e22", categoryIcon:"fa-box",
    tagline:"Official Steel Fire Cabinet Manufacturer",
    taglineAr:"المصنّع الرسمي لخزائن الحريق الفولاذية",
    about:"Titans manufactures premium heavy-gauge steel fire hose cabinets, valve boxes, and riser enclosures built to withstand harsh industrial environments and compliant with Egyptian fire codes.",
    aboutAr:"تايتانز تصنع خزائن خراطيم الحريق الفولاذية عالية الجودة وصناديق الصمامات وأغطية الارتفاع المصممة لتحمل البيئات الصناعية القاسية ومتوافقة مع كود الحريق المصري.",
    products:["Steel Hose Cabinets","Valve Enclosures","Riser Boxes","Custom Fire Panels"],
    productsAr:["خزائن خرطوم فولاذية","أغطية الصمامات","صناديق الارتفاع","لوحات حريق مخصصة"],
    certificates:["Egyptian Standard ES","ISO 9001","CE Mark"],
    applications:["Industrial Plants","Commercial Buildings","Public Infrastructure","Petrochemical Facilities"],
    applicationsAr:["المصانع الصناعية","المباني التجارية","البنية التحتية العامة","منشآت البتروكيماويات"],
    catalog:"#",
  },
  {
    id:"american-hammer", name:"American Hammer", category:"Fire Fighting", categoryAr:"إطفاء الحرائق",
    logoText:"AH", accent:"#27ae60", categoryIcon:"fa-fire-extinguisher",
    tagline:"NFPA-Grade Fire Protection Products",
    taglineAr:"منتجات حماية من الحريق وفق معايير NFPA",
    about:"American Hammer specializes in NFPA-certified fire protection hardware including sprinkler systems, dry chemical suppression, and industrial fire hose assemblies.",
    aboutAr:"أمريكان هامر متخصصة في أجهزة الحماية من الحرائق المعتمدة NFPA، بما فيها أنظمة الرشاشات وإخماد المواد الكيميائية الجافة وتجميعات خراطيم الحريق الصناعية.",
    products:["Fire Hose Assemblies","Dry Chemical Units","Sprinkler Heads UL/FM","Pressure Gauges"],
    productsAr:["تجميعات خرطوم الحريق","وحدات المواد الكيميائية الجافة","رشاشات UL/FM","مقاييس الضغط"],
    certificates:["UL Listed","FM Global","NFPA Compliant","ANSI Certified"],
    applications:["Aviation Hangars","Oil & Gas","Manufacturing","Data Centers"],
    applicationsAr:["أحظان الطائرات","النفط والغاز","التصنيع","مراكز البيانات"],
    catalog:"#",
  },
  {
    id:"mereco", name:"Mereco Electric", category:"Low Voltage", categoryAr:"جهد منخفض",
    logoText:"ME", accent:"#8e44ad", categoryIcon:"fa-bolt",
    tagline:"LV Switchboard & Control Panel Partner",
    taglineAr:"الشريك في لوحات التوزيع وأنظمة التحكم",
    about:"Mereco Electric manufactures certified low-voltage distribution boards, ATS panels, and industrial control systems meeting IEC and local Egyptian standards.",
    aboutAr:"ميريكو إليكتريك تصنع لوحات توزيع الجهد المنخفض المعتمدة ولوحات ATS وأنظمة التحكم الصناعية وفق معايير IEC والمعايير المصرية.",
    products:["MDB/SMDB Panels","ATS Transfer Switches","Power Factor Correction Units","Motor Control Centers"],
    productsAr:["لوحات MDB/SMDB","مفاتيح تحويل ATS","وحدات تصحيح معامل القدرة","مراكز التحكم في المحركات"],
    certificates:["IEC 61439","CE Mark","ISO 9001","Egyptian Electrical Code"],
    applications:["Industrial Factories","Commercial Buildings","Data Centers","Hospitals"],
    applicationsAr:["المصانع الصناعية","المباني التجارية","مراكز البيانات","المستشفيات"],
    catalog:"#",
  },
  {
    id:"capital-plus", name:"Capital Plus", category:"Infrastructure", categoryAr:"البنية التحتية",
    logoText:"CP", accent:"#16a085", categoryIcon:"fa-network-wired",
    tagline:"Heavy Civil & MEP Infrastructure Partner",
    taglineAr:"الشريك في البنية التحتية المدنية الثقيلة وMEP",
    about:"Capital Plus provides heavy-duty civil infrastructure solutions including underground utility networks, pipe laying, and large-scale MEP project coordination across Egypt's industrial zones.",
    aboutAr:"كابيتال بلاس تقدم حلول البنية التحتية المدنية الثقيلة بما فيها شبكات المرافق تحت الأرض وأعمال مد الأنابيب وتنسيق مشاريع MEP الضخمة عبر المناطق الصناعية المصرية.",
    products:["Underground Piping Networks","Cable Duct Systems","Civil Foundation Works","MEP Coordination"],
    productsAr:["شبكات أنابيب تحت الأرض","أنظمة قنوات الكابلات","أعمال الأساسات المدنية","تنسيق MEP"],
    certificates:["ISO 9001","OHSAS 18001","Egyptian Building Code"],
    applications:["Industrial Zones","Utility Networks","Government Projects","Real Estate"],
    applicationsAr:["المناطق الصناعية","شبكات المرافق","المشاريع الحكومية","العقارات"],
    catalog:"#",
  },
  {
    id:"aram-tech", name:"Aram Tech", category:"Fire Alarm", categoryAr:"إنذار الحريق",
    logoText:"AR", accent:"#d35400", categoryIcon:"fa-bell",
    tagline:"Intelligent Alarm & Detection Systems",
    taglineAr:"أنظمة الإنذار والكشف الذكية",
    about:"Aram Tech is an authorized distributor of addressable fire alarm systems, integrating Simplex, Apollo, and Honeywell into complete life-safety solutions.",
    aboutAr:"ارام تك موزع معتمد لأنظمة إنذار الحريق القابلة للعنونة، يدمج ماركات سيمبلكس وأبولو وهانيويل في حلول سلامة متكاملة.",
    products:["Addressable Control Panels","Laser Smoke Detectors","Voice Evacuation Systems","Heat Detectors"],
    productsAr:["لوحات تحكم قابلة للعنونة","كاشفات دخان بالليزر","أنظمة الإخلاء الصوتي","كاشفات الحرارة"],
    certificates:["UL Listed","EN 54 Certified","NFPA 72","FM Approved"],
    applications:["High-Rise Buildings","Hospitals","Malls","Airports"],
    applicationsAr:["المباني الشاهقة","المستشفيات","المراكز التجارية","المطارات"],
    catalog:"#",
  },
  {
    id:"al-attar", name:"Al Attar Contracting", category:"Contracting", categoryAr:"المقاولات",
    logoText:"AA", accent:"#2c3e50", categoryIcon:"fa-hard-hat",
    tagline:"Strategic MEP Contracting Partner",
    taglineAr:"الشريك الاستراتيجي في مقاولات MEP",
    about:"Al Attar Contracting is one of Egypt's established MEP contracting firms, collaborating on large-scale fire protection, electrical, and mechanical installations.",
    aboutAr:"العطار للمقاولات من أبرز شركات مقاولات MEP في مصر، تتعاون في تركيبات الحماية من الحريق والكهرباء والميكانيكا الضخمة.",
    products:["MEP Full Turnkey","Fire Protection Installation","Electrical Infrastructure","Commissioning Services"],
    productsAr:["مقاولات MEP كاملة","تركيب أنظمة الحماية من الحريق","البنية التحتية الكهربائية","خدمات التشغيل"],
    certificates:["ISO 9001","OHSAS 18001","Egyptian Contractors Federation"],
    applications:["Mega Projects","Industrial Complexes","Commercial Towers","Government Facilities"],
    applicationsAr:["المشاريع الضخمة","المجمعات الصناعية","الأبراج التجارية","المنشآت الحكومية"],
    catalog:"#",
  },
];
